import { IconPlaceDown, IconPickUp } from '@/icons';
import { Flex } from '@/ui/Flex/Flex';
import { T } from '@/ui/Text/Text';
import { memo } from 'react';
import { useIntl } from 'react-intl';
import SensorHandle from '../SensorHandle';
import { SensorNFCAllNodeType } from '../types';
import BaseNode from '../BaseNode';

export const SensorNFCNodeAll = memo(
  ({
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    data,
    selected,
  }: {
    data: SensorNFCAllNodeType['data'];
    selected?: boolean;
  }) => {
    const intl = useIntl();
    return (
      <BaseNode
        selected={selected ?? false}
        type="sensor"
        isValid={data.isValid}
      >
        <Flex direction="column">
          <T h4>
            {intl.formatMessage({
              defaultMessage: 'All NFC Readers',
              id: 'TGcYbX',
            })}
          </T>
          <T body2>
            {intl.formatMessage({
              defaultMessage: 'NFC Settings',
              id: 'rNVEzL',
            })}
          </T>
        </Flex>
        <div style={{ width: '1px', background: 'white' }} />
        <Flex direction="column" grow gap={4} justify="center">
          <Flex align="center" gap={4}>
            <IconPlaceDown />
            <T body2>
              {intl.formatMessage({
                defaultMessage: 'Place',
                id: 'VfktxJ',
              })}
            </T>
          </Flex>
          <Flex align="center" gap={4}>
            <IconPickUp />
            <T body2>
              {intl.formatMessage({
                defaultMessage: 'Take',
                id: '7VAJTh',
              })}
            </T>
          </Flex>
        </Flex>
        <SensorHandle id="active" posTop="30%" />
        <SensorHandle id="passive" posTop="70%" />
      </BaseNode>
    );
  },
);
